module.exports = __webpack_public_path__ + "img/suzhouyn.8d8fe87d.png";